import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import TagRadius from '@intelligence/components/GenreSelect/components/TagRadius';
import { getLocaleText, getBubbleLabel } from '@intelligence/components/GenreSelect/utils';
import type { IBaseProps, IShortcut } from '@intelligence/components/GenreSelect/types';

import '@intelligence/components/GenreSelect/components/Shortcuts/index.scss';

interface IShortcutsProps extends IBaseProps {
  shortcuts?: IShortcut[];
  onClick?: (payload: IShortcut) => void;
}

const Shortcuts: React.FC<IShortcutsProps> = (props) => {
  const { style, className, shortcuts, onClick } = props;

  const { locale, formatMessage } = useIntl();

  return (
    <>
      {Array.isArray(shortcuts) && shortcuts.length > 0 && (
        <div style={style} className={classnames('intelligence-genre-select-shortcut', className)}>
          <div className="intelligence-select-shortcut-title">
            {formatMessage({ id: 'dbi_shortcut' })}
          </div>
          <div className="intelligence-select-shortcut-tag">
            {shortcuts
              .filter((shortcut) => shortcut?.value && (shortcut?.text || shortcut?.textCN))
              .map((shortcut) => {
                const shortcutDisabled = shortcut?.disabled;
                const shortcutValue = shortcut?.value;
                const shortcutText = getLocaleText(locale, shortcut);
                const bubbleText = getBubbleLabel(locale, shortcut);
                return (
                  <TagRadius
                    key={shortcutValue}
                    disabled={shortcutDisabled}
                    label={shortcutText}
                    bubbleLabel={bubbleText}
                    data={shortcut}
                    onClick={() => {
                      onClick?.(shortcut);
                    }}
                  />
                );
              })}
          </div>
        </div>
      )}
    </>
  );
};

export default Shortcuts;
